import cn from "classnames";
import React from "react";

const AddSvg = ({ quantity }) => {
  return (
    <svg
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Add node</title>
      <path
        className={cn("fill-white ", {
          "!fill-lightBlack dark:!fill-lightWhite": quantity >= 10,
        })}
        d="M6.5 8H0.5V6H6.5V0H8.5V6H14.5V8H8.5V14H6.5V8Z"
        fill="white"
      />
    </svg>
  );
};

export default AddSvg;
